import {
    Component,
    ContentChild,
    Directive,
    Input,
    TemplateRef,
} from '@angular/core';
import { IsActiveMatchOptions } from '@angular/router';

import { NavItem } from './nav.model';

@Directive({
    selector: 'ng-template[cmpsNavLinkContent]',
    exportAs: 'cmpsNavLinkContent',
})
export class LinkContentNavDirective {
    constructor(public templateRef: TemplateRef<any>) {}
}

@Component({
    selector: 'cmps-nav-link',
    template: ` <!--binding only target doesn't get html target attribute set-->
        <a
            [class]="className"
            [tabindex]="tabIndex"
            [attr.role]="roleName"
            [target]="navItem?.openInNewTab ? '_blank' : '_self'"
            [attr.target]="navItem?.openInNewTab ? '_blank' : '_self'"
            [routerLink]="navItem?.link"
            [queryParams]="navItem?.queryParams"
            routerLinkActive="active"
            [routerLinkActiveOptions]="
                activeOptions || {
                    paths: 'subset',
                    queryParams: 'subset',
                    fragment: 'ignored',
                    matrixParams: 'ignored'
                }
            "
            *ngIf="!navItem?.isExternal"
        >
            <ng-container
                *ngTemplateOutlet="
                    linkContent?.templateRef;
                    context: { navItem: navItem }
                "
            ></ng-container>
        </a>
        <a
            [class]="className"
            [tabindex]="tabIndex"
            [attr.role]="roleName"
            [target]="navItem?.openInNewTab ? '_blank' : '_self'"
            [attr.target]="navItem?.openInNewTab ? '_blank' : '_self'"
            [href]="navItem?.link"
            *ngIf="navItem?.isExternal"
        >
            <ng-container
                *ngTemplateOutlet="
                    linkContent?.templateRef;
                    context: { navItem: navItem }
                "
            ></ng-container>
        </a>`,
    exportAs: 'navLink',
})
export class LinkNavComponent {
    @ContentChild(LinkContentNavDirective, { static: true })
    linkContent: LinkContentNavDirective;

    @Input() className: string;
    @Input() tabIndex: number;
    @Input() roleName: string;
    @Input() activeOptions: IsActiveMatchOptions;
    @Input() navItem: NavItem;
}
